export default "__VITE_ASSET__DYjeRclv__"